import store from "store";
import { TPost } from "../../../common/types/api";

const ID = "viewed-public-plan-ids";

const getViewedIds = (): string[] => {
    return JSON.parse(store.get(ID, "[]"));
};

const storeViewedId = (newId: string) => {
    const viewedIds = getViewedIds();
    store.set(ID, JSON.stringify([...viewedIds, newId]));
};

export const publicPlanViewed = (_id: string, post: TPost) => {
    const viewedPlanIds = getViewedIds();
    if (!viewedPlanIds.some(p => p === _id)) {
        storeViewedId(_id);
        post(`plan-viewed/${_id}`, {});
    }
};
